import { Component, OnInit } from "@angular/core";
import { ApsServiceService } from "../aps-service.service";
import { Pipe, PipeTransform } from "@angular/core";
import {
  DomSanitizer,
  SafeResourceUrl,
  SafeUrl,
} from "@angular/platform-browser";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-catalogue",
  templateUrl: "./catalogue.component.html",
  styleUrls: ["./catalogue.component.css"],
})
export class CatalogueComponent implements OnInit {
  _DisplayUrls:SafeResourceUrl;
  _Mainmenu: searchelement[];
  _periodicals: searchelement[];
  _instruction: searchelement[];
  _farmers: searchelement[];
  _machine: searchelement[];
  _record: searchelement[];
  _advertising: searchelement[];
  _books: searchelement[];
  _articles: searchelement[];
  advancesearch: boolean = false;
  tickeditem: any;
  searchterm: any;
  loader: any = false;
  public empDetails: any;
  inputChanged: any = "";
  selectedItem: any = "";
  wikiItems: any[] = [];
  qitems: any;
  prdids: any;
  pdfurl: any;
  datafromapi: any;
  loaderitem:any=false;
  issubscribe:any=localStorage.getItem('issubscribe')
  datasettrue:any=false
  loaderdata:any=true
  data: any;
  subdataset: any=[];
  searchdata:any=""

  items:any
newdataset:any;

  constructor(private router: Router,private searchitem: ApsServiceService ,private toastr: ToastrService,private sanitizer:DomSanitizer) {
    // this._DisplayUrls= sanitizer.bypassSecurityTrustResourceUrl(this.urls);
    this.loaderitem = true;
    this.loaderdata=true
    this.searchitem.getsearchdocs().subscribe((responce) => {
      //console.log(responce)
      this.items=responce.datas
      this.loaderitem = true;
    
    var loopdata={}
    var checkboxdataset=[]
       for(let i=0;i<this.items.length;i++){
        loopdata={}
         this.subdataset=[]
        loopdata['id']=i+1
        loopdata['value']=this.items[i].searchcataname
        loopdata['isSelected']=false
        loopdata['isClosed']=true
        for(let j=0;j<this.items[i].searchdata.length;j++){
          let innerloop={}
          let innerdata=this.items[i].searchdata[j]
          innerloop['id']=j+1;
          innerloop['parent_id']=i+1;
          innerloop['value']=innerdata.searchname;
          innerloop['isSelected']=false
          //console.log(j,this.items[i].searchdata[j])
          this.subdataset.push(innerloop)
    
        }
        loopdata['childList']=this.subdataset
        //console.log(this.subdataset,"push")
        checkboxdataset.push(loopdata)
      }
      //console.log(checkboxdataset)
    
         
    
    this.data = {};

    this.data.isAllSelected = false;
    this.data.isAllCollapsed = false;


    //List object having hierarchy of parents and its children
    this.data.ParentChildchecklist=checkboxdataset
    this.datasettrue=true
    this.loaderitem = false;
    this.loaderdata=false
  })
  }

  printout(getprint:any){
    //console.log(getprint)
    this._DisplayUrls="";
    this._DisplayUrls= this.sanitizer.bypassSecurityTrustResourceUrl(getprint);

  }
  ngOnInit(): void {
    
 

    if(this.issubscribe === 'false'){
      this.router.navigate(["/userpage"])
    }


    //console.log(this.advancesearch);
    $(".clicks").click(function () {
      if ($(this).next().css("display") == "none") {
        $(this).next().css("display", "block");
      } else {
        $(this).next().css("display", "none");
      }
    });
  }
  popup(){
    if ($('.popup').css("display") == "none") {
      $('.popup').css("display", "inline-block");
    } else {
      $('.popup').css("display", "none");
    }

  }

  opener(event) {
    //console.log(event);

    if ($("dropelement").next().css("display") == "none") {
      $("dropelement").next().css("display", "block");
    } else {
      $("dropelement").next().css("display", "none");
    }
  }


  onsubmitbtn() {
    console.log('click')
    this._DisplayUrls="";
    this.loaderitem = true;
    this.tickeditem = "";
    var search = "";
    this.searchterm = this.searchdata;
    this.selectedItem

    // if ( this.searchterm == ""){
    //   this.searchterm =$(".ng-untouched").val();
    // }
  
    // this.tickeditem +=this._Mainmenu
    // .filter((x) => x.isselected == true)
    // .map((x) => x.name)
    // .join(" ");
    //console.log("searchterm = "+this.searchterm)
    //console.log(this.tickeditem);
    if (this.searchterm !== "") {
      search = this.searchterm;
      this.searchterm='';
    }
    if (this.selectedItem !== "") {
      search = this.selectedItem +'.txt';
      this.selectedItem='';
    }

    for(let i=0;i < this.data.ParentChildchecklist.length; i++){
      if(!this.data.ParentChildchecklist[i].isSelected){
        let testlest=this.data.ParentChildchecklist[i].childList
        //console.log("checked " + i)
        for(let j=0;j<testlest.length;j++){
          var contentitem=this.data.ParentChildchecklist[i].childList[j]
          if(contentitem.isSelected){
            this.tickeditem = this.tickeditem + " " + contentitem.value;
            //console.log(contentitem.value)
  
          }
        }
      }else if(this.data.ParentChildchecklist[i].isSelected){ 
        //console.log(this.data.ParentChildchecklist[i].value + i)
        this.tickeditem = this.tickeditem + " " + this.data.ParentChildchecklist[i].value;
      }else{
        //console.log("not checked " + i)
      }
    }

    //console.log(this.tickeditem);
    //console.log(search);
    if (this.tickeditem) {
      search += " " + this.tickeditem+'.txt';
    }
    //console.log(search);
    if (this.advancesearch) {
    //console.log("no adv search")
    } else {
      this.datafromapi=[];
      console.log(search);
      
      
    
      this.searchitem.basesearch(search).subscribe((getresponce) => {
        this.loaderitem = true;
        console.log(getresponce);
        this.qitems = getresponce.value.length;
        if(this.qitems > 0){
        this.datafromapi = getresponce.value;
        //console.log(this.qitems);
        }else{
     
          this.toastr.error("No Item Found")
        }
        this.loaderitem = false;
        this.searchterm='';
      });
    }
  
  }
  oncheckedadv(event) {
    if (event.target.checked) {
      this.advancesearch = true;
    } else {
      this.advancesearch = false;
    }
    //console.log(this.advancesearch);
  }
  imgdata(pdfurl) {
    // //console.log(pdfurl)
    this.prdids = pdfurl;
  }
  dnl(rr, aa) {}
  search() {
    // $('.ng-touched').val();
    this.loader = true;
    // this.myNameElem.nativeElement.value = "";

    // //console.log($('.ng-touched').val());
    this.empDetails = [];
    this.qitems;
    //  this.searchServices.apsblob(serchKey).subscribe(getresponce =>{
    // //  //console.log(getresponce.value)
    // //  for(let dataz of getresponce.value){
    //   //  let adata=new empdata();
    //   //  adata.content=dataz.content;
    //    this.searchServices.finlserch(getresponce.value[0].metadata_storage_path).subscribe(gtresponce =>{
    //     //  //console.log(gtresponce.value);
    //      for(let datas of gtresponce.value){
    //       //  //console.log(getresponce.value)
    //       let pdata=new empdata();
    //       pdata.content=datas.content;
    //       pdata.url=datas.url;
    //       pdata.name=datas.name;
    //       pdata.date=datas.date;
    //       pdata.category=datas.category

    //       this.empDetails.push(pdata);

    //     }
    //     this.qitems=this.empDetails.length;
    // //console.log(this.empDetails);

    //   this.loader=false;
    // })
    //   //  adata.url=dataz.metadata_storage_path;
    // //  }

    // })

    //   this.searchServices.finlserch(serchKey).subscribe(getresponce =>{
    //     //  //console.log(getresponce.value);
    //      for(let datas of getresponce.value){
    //       //  //console.log(getresponce.value)
    //       let pdata=new empdata();
    //       pdata.content=datas.content;
    //       pdata.url=datas.url;
    //       pdata.name=datas.name;
    //       pdata.date=datas.date;
    //       pdata.category=datas.category

    //       this.empDetails.push(pdata);

    //     }
    //     this.qitems=this.empDetails.length;
    // // //console.log(this.empDetails);

    //   this.loader=false;
    // })
  }
  pdfpage(uri: any) {
    sessionStorage.clear();
    sessionStorage.setItem("purl", uri);
    // this.RouterModule.navigate(['/pdfview']);
  }
  onInputChangedEvent(val: string) {
    this.inputChanged = val;
  }
  onSelect(item: any) {
    this.selectedItem = item;
    console.log(this.selectedItem)
  }

  searchd(term: string) {
    //console.log(term);

    // this.searchitem.search(term).subscribe(e => this.wikiItems = e, error => //console.log(error));
    this.searchitem.searchParam(term).subscribe((responce) => {
      this.wikiItems = [];
      let uu = [];
      // let pdata=new empdata();
      // //console.log(responce.value);
      uu = responce.value;
      // //console.log(uu)
      // pdata.state=this.wikiItems;
      for (let i = 0; i < uu.length; i++) {
        // let pdata=new empdata();
        // pdata.empname=datas.empname;
        // pdata.empcode=datas.empcode;
        // pdata.designation=datas.designation;
        // pdata.city=datas.city;
        // pdata.state=datas.state;
        // pdata.branch=datas.branch
        this.wikiItems.push(
          uu[i].metadata_storage_name.split(".").slice(0, -1).join(".")
        );
        //console.log(this.wikiItems);
      }
      // //console.log( this.wikiItems)
      // uu= this.wikiItems
    });
    this.searchdata=term
    console.log(this.searchdata)
  }
  // ===========================new cata ===================================
  
  //Click event on parent checkbox  
  parentCheck(parentObj) {
    for (var i = 0; i < parentObj.childList.length; i++) {
      parentObj.childList[i].isSelected = parentObj.isSelected;
    }
  }

  //Click event on child checkbox  
  childCheck(parentObj, childObj) {
    parentObj.isSelected = childObj.every(function (itemChild: any) {
      return itemChild.isSelected == true;
    })
  }

  //Click event on master select
  selectUnselectAll(obj) {
    obj.isAllSelected = !obj.isAllSelected;
    for (var i = 0; i < obj.ParentChildchecklist.length; i++) {
      obj.ParentChildchecklist[i].isSelected = obj.isAllSelected;
      for (var j = 0; j < obj.ParentChildchecklist[i].childList.length; j++) {
        obj.ParentChildchecklist[i].childList[j].isSelected = obj.isAllSelected;
      }
    }
  }

  //Expand/Collapse event on each parent
  expandCollapse(obj) {
    obj.isClosed = !obj.isClosed;
  }

  //Master expand/ collapse event
  expandCollapseAll(obj) {
    for (var i = 0; i < obj.ParentChildchecklist.length; i++) {
      obj.ParentChildchecklist[i].isClosed = !obj.isAllCollapsed;
    }
    obj.isAllCollapsed = !obj.isAllCollapsed;
  }

  //Just to show updated JSON object on view
  stringify(obj) {
    return JSON.stringify(obj);
  }


  subdata(){
  for(let i=0;i < this.data.ParentChildchecklist.length; i++){
    if(!this.data.ParentChildchecklist[i].isSelected){
      let testlest=this.data.ParentChildchecklist[i].childList
      //console.log("checked " + i)
      for(let j=0;j<testlest.length;j++){
        var contentitem=this.data.ParentChildchecklist[i].childList[j]
        if(contentitem.isSelected){
          //console.log(contentitem.value)

        }
      }
    }else if(this.data.ParentChildchecklist[i].isSelected){ 
      //console.log(this.data.ParentChildchecklist[i].value + i)
    }else{
      //console.log("not checked " + i)
    }
  }
   
  }
  
}




class searchelement {
  id: number;
  name: string;
  isselected: boolean;
}